import getPrefixedCookieName from './getPrefixedCookieName';

// 👇 expires in 1 year: 60 seconds x 60 minutes x 24 hours x 365 days
export const defaultExpiration = 60 * 60 * 24 * 365;

/**
 * Set the value of a cookie
 * @param {string} name - The name of the cookie
 * @param {string} value - The value of the cookie
 * @param {string} expiration - The cookie's expiration (if not provided, defaults to a session cookie)
 */
const setCookie = (unprefixedName, value, expiration = null) => {
  const name = getPrefixedCookieName(unprefixedName);
  document.cookie = [
    `${name}=${encodeURIComponent(value)}`,
    'path=/',

    // 👇 should not be set on localhost
    ...(window.headerFooterData?.cookieDomain && window.location.hostname !== 'localhost'
      ? [`domain=${window.headerFooterData.cookieDomain}`]
      : []),

    // 👇 presumed session cookie when not set
    ...(expiration ? [`max-age=${expiration}`] : []),
  ].join('; ');
};

export default setCookie;
